import { SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';

export const useExteriorDamageImages = (): SectionImage[] => {
  const { images: extImages } = useExteriorSectionData('exterior');
  const { images: tiresImages } = useExteriorSectionData('tires');
  return [...extImages, ...tiresImages].filter((img: SectionImage) => !!img.is_damaged);
};
